import { render, staticRenderFns } from "./MLEditor.vue?vue&type=template&id=9b643da6"
import script from "./MLEditor.vue?vue&type=script&lang=js"
export * from "./MLEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports